module.exports = [{"type":"title","text":"2024-08-27"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"現貨：支持OCO訂單特性，提供了OCO下單，OCO撤單，查詢單個OCO訂單，查詢委托中的OCO訂單，查詢OCO訂單訂單接口；"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-08-27.json
// module id = TvGs
// module chunks = 3